import React, { useState } from "react";
import {
  adminRoutes,
  branchManagerRoutes,
  cashierRoutes,
  itAuditorRoutes,
  superadminRoutes,
  warehouseManagerRoutes,
  storeManagerRoutes,
} from "../utils/navigations";
import NavItem from "./NavItem";
import { IoMdMenu } from "react-icons/io";
import { useGlobalContext } from "../context/stateContext";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const { activeSession, currentUser } = useGlobalContext();

  return (
    <div className="fixed lg:top-[53px] top-[38px] left-0 right-0 bg-white border border-[#ddd] z-40 shadow-sm">
      <div className="max-w-7xl mx-auto">
        <div
          className="lg:hidden flex items-center justify-center py-3 cursor-pointer"
          onClick={() => setShowMenu(!showMenu)}
        >
          <IoMdMenu size={24} />
        </div>

        {/* Desktop menu */}
        <ul className="hidden lg:flex lg:flex-row lg:items-center">
          {(() => {
            const role = activeSession?.user?.role;
            const routesByRole = {
              dispenser: cashierRoutes,
              admin: adminRoutes,
              superadmin: superadminRoutes,
              it_auditor: itAuditorRoutes,
              warehouse_manager: warehouseManagerRoutes,
              branch_manager: currentUser?.branch === activeSession?.branch?.name
                ? branchManagerRoutes
                : cashierRoutes,
              stores: storeManagerRoutes,
            };

            return routesByRole[role]?.map((route, index) => (
              <NavItem key={index} menuItem={route} setShowMenu={setShowMenu} />
            ));
          })()}
        </ul>

        {/* Mobile menu - positioned absolutely or with proper styling */}
        {showMenu && (
          <ul className="lg:hidden flex flex-col bg-white border-t border-[#ddd]">
            {(() => {
              const role = activeSession?.user?.role;
              const routesByRole = {
                dispenser: cashierRoutes,
                admin: adminRoutes,
                superadmin: superadminRoutes,
                it_auditor: itAuditorRoutes,
                warehouse_manager: warehouseManagerRoutes,
                branch_manager: branchManagerRoutes,
                stores: storeManagerRoutes,
              };

              return routesByRole[role]?.map((route, index) => (
                <NavItem
                  key={index}
                  menuItem={route}
                  setShowMenu={setShowMenu}
                />
              ));
            })()}
          </ul>
        )}
      </div>

      {/* Backdrop for mobile menu */}
      {showMenu && (
        <div
          className="fixed inset-0 bg-black/20 z-[-1] lg:hidden"
          onClick={() => setShowMenu(false)}
        />
      )}
    </div>
  );
};

export default Navbar;
